var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3415 5.67375C9.93142 6.0838 9.93142 6.74862 10.3415 7.15867L17.1823 13.9995L10.3415 20.8404C9.93142 21.2505 9.93142 21.9153 10.3415 22.3253C10.7515 22.7354 11.4163 22.7354 11.8264 22.3253L19.4097 14.742C19.8198 14.332 19.8198 13.6671 19.4097 13.2571L11.8264 5.67375C11.4163 5.2637 10.7515 5.2637 10.3415 5.67375Z",
    fill: "#E1E2E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.4adbf3c23733f8f938d332a1eb7ad9a2.svg";
export { ForwardRef as ReactComponent };